export function getQueryValue<ReturnType = any>(
  query: URLSearchParams,
  name: string,
  fallback: any = undefined
): ReturnType {
  return query.get(name) || fallback;
}
